export const appStatus = {
    updated:'2024-01-17'
}